import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'zwi-title',
    templateUrl: './title.component.html',
    styleUrls: ['./title.component.scss'],
    standalone: false
})
export class TitleComponent implements OnInit {
  @Input() offset = false;
  constructor() {}

  ngOnInit(): void {}
}
